define('adminKitcView',[
    'module',
    'marionette',
    'underscore',
    'app',
    'settings',
    'jqgridView',
    'template!adminKitcListTpl'
], function (
    module,
    Marionette,
    _,
    App,
    Settings,
    JqGridView,
    viewTpl
    ) {
    'use strict';

    var KitcListView = JqGridView.extend({
        template: viewTpl,
        filtersName: 'kitcListFilters',

        triggers: {
        },

        ui: function() {
            return _.extend({
                jqGrid: '#jq-grid-list',
                jqGridPager: '#jq-grid-pager-list',
                deleteKitc: '.delete-kitc-link'
            }, this.gridUi);
        },

        events: function() {
            return _.extend({
                'click @ui.deleteKitc': 'onDeleteKitc'
            }, this.gridEvents);
        },

        serializeData: function() {
            var templateData = {
                type: 'kitc',
                data: this.options.data
            };
            return templateData;
        },

        pagination: function() {
            return {
                first: 0,
                rowCount: 0,
                pageSize: Settings.get('perPage15'),
                currentPage: 1
            };
        },

        onDeleteKitc: function(event){
            this.trigger('kitc:delete', this.options.data.model.get('secId'), $(event.currentTarget).find('span').attr('data-row-id'));
        },

        gridOptions: function(data) {
            var options = {
                colModel: [
                    {
                        label: '',
                        name: 'secId',
                        key: true,
                        hidden: true
                    }, {
                        label: _.i18n('kitc.refKit'),
                        name: 'refKit.code',
                        classes: 'kitc-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'refKit.code'
                    }, {
                        label: _.i18n('kitc.code'),
                        name: 'code',
                        classes: 'kitc-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'code'
                    }, {
                        label: _.i18n('kitc.ctrlType'),
                        name: 'ctrlType',
                        classes: 'kitc-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'ctrlType'
                    }
                ],

                onSelectRow: function(rowId, bool, e) {
                    if (!$(e.target).hasClass('cell-delete') && e.type === 'click') {
                        if (e.type === 'click') {
                            App.navigate('admin/kitcs' + '/' + rowId, {trigger: true});
                        }
                    }
                }
            };

            if (!this.options.data.model.get('refKitSecId')) {
                options.colModel.push({
                    label: ' ',
                    name: 'delete',
                    search: false,
                    classes: 'delete-kitc-link delete-link',
                    formatter: this.deleteIconFormatter,
                    width: 20
                });
            }

            options = _.defaults(options, this.gridInitOptions(data));

            return options;
        }
    });

    module.exports = KitcListView;
});
